import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  rateTranslationText: {
    id: 'unit-translation-selector-plugin.feedbackWidget.rateTranslationText',
    defaultMessage: 'Rate this page translation',
    description: 'Title for the feedback widget action row.',
  },
  gratitudeText: {
    id: 'unit-translation-selector-plugin.feedbackWidget.gratitudeText',
    defaultMessage: 'Thank you! Your feedback matters.',
    description: 'Title for secondary action row.',
  },
  feedbackDetailsModalTitle: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.title',
    defaultMessage: 'Share Feedback',
    description: 'Title for feedback details modal.',
  },
  feedbackDetailsModalSubmitText: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.submit',
    defaultMessage: 'Submit Feedback',
    description: 'Submit button text for feedback details modal.',
  },
  feedbackDetailsModalPlaceholder: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.placeholder',
    defaultMessage: 'Optional: enter aditional feedback',
    description: 'Placeholder for feedback details modal textarea',
  },
  feedbackDetailsModalCheckboxBroken: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.reason.broken',
    defaultMessage: 'Something is broken',
    description: 'Checkbox text for reason: broken',
  },
  feedbackDetailsModalCheckboxHarmful: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.reason.harmful',
    defaultMessage: 'This is harmful or unsafe',
    description: 'Checkbox text for reason: harmful',
  },
  feedbackDetailsModalCheckboxNotAccurate: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.reason.notaccurate',
    defaultMessage: 'This is not accurate/helpful',
    description: 'Checkbox text for reason: notaccurate',
  },
  feedbackDetailsModalCheckboxElse: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.reason.else',
    defaultMessage: 'Something else',
    description: 'Checkbox text for reason: else',
  },
  feedbackDetailsModalEmailMeText: {
    id: 'unit-translation-selector-plugin.feedbackWidget.feedbackDetailsModal.emailme',
    defaultMessage: 'It’s ok to email me about my response',
    description: 'Text for email me checkbox',
  },
});

export default messages;
